//imports
import "./../css/maps.scss";
import $ from "jquery";
import {Loader} from "@googlemaps/js-api-loader";
import {MarkerClusterer} from "@googlemaps/markerclusterer";

//config
const ZOOM_ON_LOAD = /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent) ? 6.8 : 8.0;
const MAP_API_KEY = 'AIzaSyCrs14WyhEvhW7-8Y9F_Rzrx1Q45xyE6sI';
const MAP_ID = 'e35b99cf31277cb4';
// const MAP_CENTER = new google.maps.LatLng(46.1, 15);
const MAP_CENTER = {lat: 46.1, lng: 15};

const url = window.location.href.split('?')[0];

//card click

$('.provider-card').on('click', function () {
    let permalink = $(this).attr('permalink');
    window.open(permalink, "_self");
});

// search
function toggleSearchElements() {
    $('#search-input, #close-button').animate({width: 'toggle', opacity: 'toggle'}, 500);
}

function toggleSearchElementsMobile() {
    $('#search-input-mobile, #close-button-mobile').animate({display: 'toggle'}, 500);
}

function searchProviders() {
    const searchButton = $(this);

    if (searchButton.hasClass('active')) {
        const searchTerm = $('#search-input').val().toLowerCase();
        const providerCards = $('.provider-card');

        providerCards.each(function () {
            const card = $(this);
            const title = card.attr('title').toLowerCase();
            card.toggle(title.includes(searchTerm));
        });

        const visibleCardsCount = providerCards.filter(':visible').length;
        $('#counter').text(visibleCardsCount);
        $('#counter-mobile').text(visibleCardsCount);

    } else {
        searchButton.addClass('active');
        toggleSearchElements();
        $('#search-input').focus();
    }
}

function searchProvidersMobile() {
    const searchButton = $(this);

    if ($('#map-menu-switch-display').text().replace(/\s+/g, "") === $('#map-menu-switch-display').attr('data-label-seznam')) {
        $('#map-menu-switch-display').click();
    }

    if (searchButton.hasClass('active')) {
        const searchTerm = $('#search-input-mobile').val().toLowerCase();
        const providerCards = $('.provider-card');

        providerCards.each(function () {
            const card = $(this);
            const title = card.attr('title').toLowerCase();
            card.toggle(title.includes(searchTerm));
        });
    } else {
        searchButton.addClass('active');
        searchButton.parent().parent().addClass('active');

        toggleSearchElementsMobile();
    }
}

function closeSearch() {
    // Clear the search input
    $('#search-input').val('');  // This will empty the search field

    $('#search-input, #close-button').animate({width: 'toggle', opacity: 'toggle'}, 300);
    $('#search-button').removeClass('active');
}

function closeSearchMobile() {
    // Clear the search input
    $('#search-input-mobile').val('');  // This will empty the search field

    $('#search-input-mobile, #close-button-mobile').animate({display: 'toggle'}, 300);
    $('#search-button-mobile').removeClass('active');
    $('#search-button-mobile').parent().parent().removeClass('active');

    if ($('#map-menu-switch-display').text().replace(/\s+/g, "") === $('#map-menu-switch-display').attr('data-label-zemljevid')) {
        $('#map-menu-switch-display').click();
    }

    $('#counter-mobile').text($('#counter-mobile').attr('data-counter-mobile'));
}

$('#close-button').on('click', closeSearch);
$('#close-button-mobile').on('click', closeSearchMobile);
$(document).on('keydown', function (e) {
    if (e.key === 'Enter') {
        if ($('#search-button').hasClass('active')) {
            const searchTerm = $('#search-input').val().toLowerCase();
            const providerCards = $('.provider-card');

            providerCards.each(function () {
                const card = $(this);
                const title = card.attr('title').toLowerCase();
                card.toggle(title.includes(searchTerm));
            });

            const visibleCardsCount = providerCards.filter(':visible').length;
            $('#counter').text(visibleCardsCount);
            $('#counter-mobile').text(visibleCardsCount);

        }
    }
    if (arguments[0]["keyCode"] === 13) {
        if ($('#search-button-mobile').hasClass('active')) {
            const searchTerm = $('#search-input-mobile').val().toLowerCase();
            const providerCards = $('.provider-card');

            providerCards.each(function () {
                const card = $(this);
                const title = card.attr('title').toLowerCase();
                card.toggle(title.includes(searchTerm));
            });

            const visibleCardsCount = providerCards.filter(':visible').length;
            $('#counter').text(visibleCardsCount);
            $('#counter-mobile').text(visibleCardsCount);
        }
    }
});

$('#search-button').on('click', searchProviders);
$('#search-button-mobile').on('click', searchProvidersMobile);

// label update

function updateFilterLabel(extraFilters, updateOnClick, enableMultiselect) {
    const singleSelectHandler = function () {
        $(extraFilters + " .filter-depth-1").on('change', function () {
            $(extraFilters + " .filter-depth-1").not($(this)).prop('checked', false);
            updateLabel($(this).closest('.map-filters__label').find('span'));
        });
    };

    const multiSelectHandler = function () {
        $(extraFilters + " .use").on('click', function () {
            let labelsArray = [];
            $(extraFilters + " input.filter-depth-1:checked").each(function () {
                let inputId = $(this).attr('id');
                let labelText = $('label[for="' + inputId + '"]').text();
                labelsArray.push(labelText);
            });
            updateMultiLabel($(this).closest('.map-filters__label').find('span'), labelsArray);
        });
    };

    const singleClickHandler = function () {
        $(extraFilters + " .filter-depth-1").on('change', function () {
            $(extraFilters + " .filter-depth-1").not($(this)).prop('checked', false);
        });
        $(extraFilters + " .use").on('click', function () {
            updateLabel($(this).closest('.map-filters__label').find('span'));
        });
    };

    const updateLabel = function (filterLabel) {
        let inputId = $(extraFilters + " .filter-depth-1:checked").attr('id');
        let labelText = $('label[for="' + inputId + '"]').text();
        let filterPlaceholder = filterLabel.attr('data-placeholder');

        if (labelText) {
            filterLabel.text(labelText);
            filterLabel.closest('.map-filters__filter').addClass('close');
        } else {
            filterLabel.text(filterPlaceholder);
            filterLabel.closest('.map-filters__filter').removeClass('close');
        }
    };

    const updateMultiLabel = function (filterLabel, labelsArray) {
        let filterPlaceholder = filterLabel.attr('data-placeholder');

        if (labelsArray.length === 0) {
            filterLabel.text(filterPlaceholder);
            filterLabel.closest('.map-filters__filter').removeClass('close');
        } else if (labelsArray.length === 1) {
            filterLabel.text(labelsArray[0]);
            filterLabel.closest('.map-filters__filter').addClass('close');
        } else {
            filterLabel.text(filterPlaceholder + ' (' + labelsArray.length + ')');
            filterLabel.closest('.map-filters__filter').addClass('close');
        }
    };

    if (updateOnClick) {
        if (enableMultiselect) {
            multiSelectHandler();
        } else {
            singleClickHandler();
        }
    } else {
        if (!enableMultiselect) {
            singleSelectHandler();
        }
    }
}

function updateProduceFilterLabel(produceFilters) {
    const applyFilter = function () {
        $(produceFilters + " .use").on('click', function () {
            updateLabel($(this).closest('.map-filters__label').find('span'));
        });
    };

    const resetFilter = function () {
        $(produceFilters + " .reload").on('click', function () {
            clearFilters($(this).closest('.map-filters__label').find('span'));
        });
    };

    const updateLabel = function (filterLabel) {
        let selectedFirstLayer = $(produceFilters + " .filter-depth-1:checked");
        let selectedSecondLayer = $(produceFilters + " .filter-depth-2:checked");
        let filterPlaceholder = filterLabel.attr('data-placeholder');

        if (selectedSecondLayer.length > 1) {
            // More than one second-layer filter selected: use placeholder and count
            filterLabel.text(filterPlaceholder + ' (' + selectedSecondLayer.length + ')');
            filterLabel.closest('.map-filters__filter').addClass('close');
        } else if (selectedSecondLayer.length === 1) {
            // Only one second-layer filter selected: use its label
            let inputId = selectedSecondLayer.attr('id');
            let labelText = $('label[for="' + inputId + '"]').text();
            filterLabel.text(labelText);
            filterLabel.closest('.map-filters__filter').addClass('close');
        } else if (selectedFirstLayer.length > 1) {
            // More than one first-layer filter selected: use placeholder and count
            filterLabel.text(filterPlaceholder + ' (' + selectedFirstLayer.length + ')');
            filterLabel.closest('.map-filters__filter').addClass('close');
        } else if (selectedFirstLayer.length === 1) {
            // Only one first-layer filter selected: use its label
            let inputId = selectedFirstLayer.attr('id');
            let labelText = $('label[for="' + inputId + '"]').text();
            filterLabel.text(labelText);
            filterLabel.closest('.map-filters__filter').addClass('close');
        } else {
            // No filter selected: reset to placeholder
            filterLabel.text(filterPlaceholder);
            filterLabel.closest('.map-filters__filter').removeClass('close');
        }
    };

    const clearFilters = function (filterLabel) {
        // Reset all inputs and set placeholder
        $(produceFilters + " input").prop('checked', false);
        let filterPlaceholder = filterLabel.attr('data-placeholder');
        filterLabel.text(filterPlaceholder);
        filterLabel.closest('.map-filters__filter').removeClass('close');
    };

    // Apply event listeners
    applyFilter();
    resetFilter();
}

// Initialize the updated functionality
updateProduceFilterLabel("#produce-filters");


updateFilterLabel("#region-filters", false, false);
updateFilterLabel("#certificate-filters", true, true);
updateFilterLabel("#type-filters", true, true);
updateFilterLabel("#extra-filters", true, true);

//label remove

function updateFilterLabelRemove() {
    $('.map-filters__label').on('click', function (e) {
        let $filter = $(this).closest('.map-filters__filter');
        if ($filter.hasClass('close') && e.target === this) {
            $filter.removeClass('close');
            let $filterSpan = $filter.find('span');
            $filterSpan.text($filterSpan.attr('data-placeholder'));
            $filter.find('input:checked').prop('checked', false);
        }
    });
}

updateFilterLabelRemove();

// two level filter label

function updateTwoLevelFilterLabel(filterId) {
    const $filter = $(filterId);
    $filter.on('change', 'input.filter-depth-2', function () {
        const $this = $(this);
        const secondLvlCategory = $this.closest('.subfields').attr('data');
        const $label = $('label[for="' + secondLvlCategory + '"]');
        const $subfields = $('.subfields[data="' + secondLvlCategory + '"]');
        const counter = $subfields.find('input:checked').length;

        if (!$label.attr('data-placeholder')) {
            $label.attr('data-placeholder', $label.text());
        }

        $label.text($label.attr('data-placeholder') + (counter > 0 ? ' (' + counter + ')' : ''));
    });
}

updateTwoLevelFilterLabel('#produce-filters');

function updateTwoLevelFilterLabelOnReset(filterId) {

    $(filterId + ' .reload').on('click', function () {

        $(filterId + ' label.filter-depth-1').each(function () {
            if ($(this).attr('data-placeholder') !== "undefined") {
                $(this).text($(this).attr('data-placeholder'));
            }
        });
    });

}

updateTwoLevelFilterLabelOnReset('#produce-filters');

let providerData = {};
let markersById = {};

$("#produce-filters input.filter-depth-1").on("click", function () {
    let id = $(this).attr('id');
    let subfield = $(".subfields[data='" + id + "']");

    $('.subfields').removeClass('active');
    subfield.addClass('active');

    $("#produce-filters input.filter-depth-1").each(function () {
        $(this).prop('checked', false);
    });

    $(this).prop('checked', true);
});

function setupCertificateFilters(containerId) {
    $(`${containerId} .reload`).on('click', function () {
        $(containerId).removeClass('close');
        $(containerId + " span").text($(containerId + " span").attr("data-placeholder"));
        $('.subfields').removeClass('active');

        $(`${containerId} input`).each(function () {
            $(this).prop('checked', false);
        });
    });
}

setupCertificateFilters("#produce-filters");
setupCertificateFilters("#certificate-filters");
setupCertificateFilters("#type-filters");
setupCertificateFilters("#extra-filters");

/* global google */
/* eslint no-undef: "error" */

const loader = new Loader({
    apiKey: MAP_API_KEY, version: "weekly"
});

let mapOptions = {
    center: MAP_CENTER,
    zoom: ZOOM_ON_LOAD,
    mapId: MAP_ID,
    mapTypeControl: false,           // Disables map/satellite buttons
    streetViewControl: false,         // Disables Street View control
    fullscreenControl: false,         // Disables fullscreen control
    zoomControl: false,               // Disables zoom buttons
    gestureHandling: "greedy"         // Makes map consume all touch/scroll events
};

function filterMarkers(fetchProviders, AdvancedMarkerElement, map) {
    let params = {};

    function gatherCheckedValues(selector) {
        return $(selector + ' input[type="checkbox"]:checked').map(function () {
            return $(this).attr('value');
        }).get().join(',');
    }

    let region = gatherCheckedValues('#region-filters');
    if (region) {
        params.region = region;
    }

    let produce = gatherCheckedValues('#produce-filters');
    if (produce) {
        params.produce = produce;
    }

    let extra = gatherCheckedValues('#extra-filters');
    if (extra) {
        params.extra = extra;
    }

    let type = gatherCheckedValues('#type-filters');
    if (type) {
        params.type = type;
    }

    let certificate = gatherCheckedValues('#certificate-filters');
    if (certificate) {
        params.certificate = certificate;
    }

    // Update map options: set a new center and zoom
    map.setOptions({
        center: MAP_CENTER,  // Adjust this if you want to center based on filter results
        zoom: ZOOM_ON_LOAD   // You can set a different zoom level here based on your needs
    });

    fetchProviders(params, AdvancedMarkerElement, map);
}

$(function () {

    const initializeMap = async () => {
        await loader.load();
        const {Map} = await google.maps.importLibrary("maps");
        const {AdvancedMarkerElement} = await google.maps.importLibrary("marker");

        const map = new Map(document.getElementById("map"), mapOptions);

        map.addListener("drag", () => {
            onMapDrag();
        });

        return {AdvancedMarkerElement, map};
    };

    const createMarkers = (data, AdvancedMarkerElement, map) => {
        let markers = [];
        providerData = {};
        markersById = {}; // Clear previous markers

        data.forEach(item => {
            if (item.location.lat > 0 && item.location.lng > 0) {
                providerData[item.id] = item;

                const markerContent = document.createElement("div");
                markerContent.className = "marker-content marker-id-" + item.id;

                const iconContainer = document.createElement("div");
                iconContainer.className = "icon-container";

                if (item.icons.length === 0) {
                    const img = document.createElement("img");
                    img.className = "marker-icon";
                    iconContainer.appendChild(img);
                } else {

                    if (Array.isArray(item.icons)) {
                        item.icons.slice(0, 3).forEach(iconUrl => {
                            const img = document.createElement("img");
                            img.src = iconUrl;
                            img.className = "marker-icon";
                            iconContainer.appendChild(img);
                        });

                        if (item.icons.length > 3) {
                            const remainingCount = document.createElement("div");
                            remainingCount.className = "remaining-count";
                            remainingCount.textContent = `+${item.icons.length - 3}`;
                            iconContainer.appendChild(remainingCount);
                        }
                    }

                }
                markerContent.appendChild(iconContainer);

                try {
                    const marker = new AdvancedMarkerElement({
                        map: map,
                        position: {lat: item.location.lat, lng: item.location.lng},
                        content: markerContent,
                    });

                    marker.itemId = item.id;
                    markersById[item.id] = marker; // Store marker by itemId

                    marker.addListener("click", () => {
                        $('.provider-card').removeClass('active');
                        $('.marker-content').removeClass('active');

                        $('.marker-id-' + item.id).addClass('active');

                        let card = $(`#${item.id}`).addClass('active');

                        card[0].scrollIntoView({behavior: "smooth", block: "center"});
                        let popupMobile = $('#map .popup-mobile');

                        if (popupMobile.length === 0) {
                            popupMobile = $('<div class="popup-mobile"></div>').appendTo('#map');

                        }
                        card[0].scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });

                        card.find('.provider-card').css('display', '');
                        card.find('.provider-card').removeClass('active');

                        const clonedCard = card.clone();
                        clonedCard.on('click', function () {
                            let permalink = $(this).attr('permalink');
                            window.open(permalink, "_self");
                        });

                        popupMobile.html(clonedCard);

                    });

                    markers.push(marker);
                } catch (error) {
                    console.error('Error creating marker:', error);
                }
            } else {
                console.warn('Invalid location for item:', item);
            }
        });

        window.providerData = providerData;

        return markers;
    };


    const fetchProviders = (params, AdvancedMarkerElement, map) => {
        const urlParams = new URLSearchParams(params);

        window.history.pushState('data', 'data', url.slice(0, -1) + '?' + urlParams.toString());

        return fetch('/wp-json/maps/v1/ponudniki?' + urlParams.toString())
            .then(response => response.json())
            .then(data => {
                if (window.currentMarkers) {
                    window.currentMarkers.forEach(marker => marker.setMap(null));
                }

                window.currentMarkers = [];

                window.currentMarkers = createMarkers(data, AdvancedMarkerElement, map);

                if (window.markerClusterer) {
                    window.markerClusterer.clearMarkers();
                }

                window.markerClusterer = new MarkerClusterer({
                    map,
                    markers: window.currentMarkers,
                });

                updateProviderCards(data, map);
                updateVisibleProviders(map);

                google.maps.event.addListener(map, 'bounds_changed', function () {
                    updateVisibleProviders(map);
                });
            })
        // .catch(error => {
        //     console.error('Error:', error);
        // });
    };

    const updateProviderCards = () => {
        let providersSelector = $('#providers .provider-card');
        providersSelector.each(function (index, element) {
            $(element).hide();
        });
    };

    const updateVisibleProviders = (map) => {
        const bounds = map.getBounds();
        let visibleProviders = 0;

        $(".provider-card").each(function () {
            const providerId = $(this).attr('id');
            const provider = window.providerData[providerId];
            if (provider && provider.location) {
                const providerPosition = new google.maps.LatLng(provider.location.lat, provider.location.lng);

                if (bounds.contains(providerPosition)) {
                    $(this).show();
                    visibleProviders++;
                } else {
                    $(this).hide();
                }
            }
        });

        $('#counter').text(visibleProviders);
        $('#counter-mobile').text(visibleProviders);
        $('#counter-mobile').attr('data-counter-mobile', visibleProviders);
    };

    const getUrlParameter = (name) => {
        const url = window.location.href;
        name = name.replace(/[[]]/g, '$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        const results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return '';
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };

    const applyFiltersFromUrl = () => {
        const filters = ['region', 'produce', 'extra', 'type', 'certificate'];
        let params = {};

        filters.forEach(filter => {
            const value = getUrlParameter(filter);
            if (value) {
                value.split(',').forEach(val => {
                    const checkbox = $(`input[type="checkbox"][value="${val}"]`);
                    if (checkbox.length) {
                        checkbox.prop('checked', true);
                    }
                });
                params[filter] = value;
            }
        });

        return params;
    };

    initializeMap().then(({AdvancedMarkerElement, map}) => {
        const initialParams = applyFiltersFromUrl();
        fetchProviders(initialParams, AdvancedMarkerElement, map).then();

        if ('extra' in initialParams) {
            let arr = initialParams.extra.split(',');
            let label = $('label[for="' + arr[0] + '"]');
            label.closest('.map-filters__filter').addClass('close');
            if (arr.length === 1) {
                label.closest('.map-filters__label').find('span').text(label.text());
            } else {
                label.closest('.map-filters__label').find('span').text(label.closest('.map-filters__label').find('span').attr('data-placeholder') + ' (' + arr.length + ')');
            }
        }
        if ('type' in initialParams) {
            let arr = initialParams.type.split(',');
            let label = $('label[for="' + arr[0] + '"]');
            label.closest('.map-filters__filter').addClass('close');
            if (arr.length === 1) {
                label.closest('.map-filters__label').find('span').text(label.text());
            } else {
                label.closest('.map-filters__label').find('span').text(label.closest('.map-filters__label').find('span').attr('data-placeholder') + ' (' + arr.length + ')');
            }
        }
        if ('certificate' in initialParams) {
            let arr = initialParams.certificate.split(',');
            let label = $('label[for="' + arr[0] + '"]');
            label.closest('.map-filters__filter').addClass('close');
            if (arr.length === 1) {
                label.closest('.map-filters__label').find('span').text(label.text());
            } else {
                label.closest('.map-filters__label').find('span').text(label.closest('.map-filters__label').find('span').attr('data-placeholder') + ' (' + arr.length + ')');
            }
        }
        if ('region' in initialParams) {
            let label = $('label[for="' + initialParams.region + '"]');
            label.closest('.map-filters__label').find('span').text(label.text());
            label.closest('.map-filters__filter').addClass('close');
        }
        if ('produce' in initialParams) {
            let arr = initialParams.produce.split(',');
            if (arr.length > 1) {
                arr = arr.filter(item => /\d/.test(item));
            }
            let label = $('label[for="' + arr[0] + '"]');
            label.closest('.map-filters__filter').addClass('close');
            if (arr.length === 1) {
                label.closest('.map-filters__label').find('span').text(label.text());
            } else {
                label.closest('.map-filters__label').find('span').text(label.closest('.map-filters__label').find('span').attr('data-placeholder') + ' (' + arr.length + ')');
            }
        }

        $(".reload, .use").on("click", function () {
            filterMarkers(fetchProviders, AdvancedMarkerElement, map);
        });
        $('#close-button').on("click", function () {
            filterMarkers(fetchProviders, AdvancedMarkerElement, map);
        });

        $("#region-filters input").on("change", function () {
            filterMarkers(fetchProviders, AdvancedMarkerElement, map);
        });

        $(".map-filters__label").on("click", function (e) {
            if (e.target === this) {
                filterMarkers(fetchProviders, AdvancedMarkerElement, map);
            }
        });

        function clearAllFilters() {
            // Reset all checkboxes in the filter sections
            $('.map-filters input[type="checkbox"]').prop('checked', false);

            // Reset all filter labels to their placeholders
            $('.map-filters__label span').each(function () {
                const placeholder = $(this).attr('data-placeholder');
                $(this).text(placeholder);
            });

            // Remove the 'close' class from all filter containers
            $('.map-filters__filter').removeClass('close');

            // Clear any subfields that were active
            $('.subfields').removeClass('active');

            // Update the map and provider list
            filterMarkers(fetchProviders, AdvancedMarkerElement, map);
        }

        $('#map-filters__clear span').on('click', function () {
            clearAllFilters();
        });

    });
});

//mobile FE

function onMapDrag() {
    let popupMobile = $('#map .popup-mobile');

    if (popupMobile.length !== 0) {
        popupMobile.remove();
    }
}

function toggleFilterBlock() {
    const filterBlock = $('.map-filters');
    $('.use').each(function () {
        $(this).click();
    });
    filterBlock.toggleClass('active');
}

$(document).ready(function () {
    if (window.innerWidth <= 768) { // Adjust the width threshold as needed for "mobile"

        const mapBlock = $('.map-block__map');
        const listBlock = $('.map-block__list');
        const filterBlock = $('.map-filters');
        const filterBlockClose = $('.article-filter-box-close');
        const switchDisplay = $('#map-menu-switch-display');
        const switchFilter = $('#map-menu-switch-filter');
        const useButton = $('.map-filters__use-mobile');
        const clearButton = $('.map-filters__clear-mobile');

        mapBlock.addClass('active');

        if (switchDisplay.length) {
            switchDisplay.on('click', function () {
                const $this = $(this);
                $this.toggleClass('active');
                const zemljevidLabel = $this.attr('data-label-zemljevid');
                const seznamLabel = $this.attr('data-label-seznam');
                $this.text($this.hasClass('active') ? zemljevidLabel : seznamLabel);

                if ($this.hasClass('active')) {
                    listBlock.addClass('active');
                    mapBlock.removeClass('active');
                    $this.removeClass('list-icon');
                    $this.addClass('map-icon');
                } else {
                    mapBlock.addClass('active');
                    listBlock.removeClass('active');
                    $this.addClass('list-icon');
                    $this.removeClass('map-icon');
                }

                let popupMobile = $('#map .popup-mobile');

                if (popupMobile.length !== 0) {
                    popupMobile.remove();
                }

            });

            switchFilter.on('click', function () {
                filterBlock.toggleClass('active');
                let popupMobile = $('#map .popup-mobile');

                if (popupMobile.length !== 0) {
                    popupMobile.remove();
                }
            });

            filterBlockClose.on('click', toggleFilterBlock);
            useButton.on('click', toggleFilterBlock);
            clearButton.on('click', toggleFilterBlock);
        }
    }
});

